<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'运营成果配置',goback:true},{name:'编辑运营成果'}]" :title="'编辑运营成果'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                  <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="内容名称" prop="name">
            <el-input v-model="ruleForm.title" maxlength="64"></el-input>
          </el-form-item>
          <el-form-item label="基数" prop="baseNum">
            <el-input v-model.number="ruleForm.baseNum" maxlength="12"></el-input>
          </el-form-item>
          <!-- <el-form-item label="系统数据" prop="sysNum">
            <el-input v-model="ruleForm.sysNum"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="数据总和" prop="totalNum">
            <el-input v-model="ruleForm.totalNum"></el-input>
          </el-form-item> -->
          <el-form-item label="状态" prop="status" class="formitem">
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="submitForm('ruleForm')"
              >确认</el-button>
              <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
          </el-form-item>
        </el-form>
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';

export default {
    components:{
        breadcrumb,
    },
    data(){
        return{
            id:void 0,
            classifyList: [], //分类
            ruleForm: {
              id: void 0,
              title: void 0,
              baseNum: void 0,
              status: void 0,

            },
            edit: false, //是否编辑
            newsDataSelect: [],
            rules: {
              baseNum: [{ required: true, message: "请输入基数", trigger: "blur" }]
              // sysNum: [
              //   { required: true, message: "请输入系统数据", trigger: "blur" },
              // ],
              // title: [{ required: true, message: "请输入内容", trigger: "blur" }],
              // totalNum: [
              //   { required: true, message: "请输入数据总和", trigger: "blur" },
              // ],
            },
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    methods:{
      getDetail(id){
			this.$axiosc.get(`/backstage/hotOperational/details/${id}`).then((r)=>{
			    if(r.code==200){
                       this.ruleForm = Object.assign(this.ruleForm,r.data)
                    }else{
                        this.$alert(r.msg)
                    }
			})
		},
      resetForm(formName) {
      // this.ruleForm = {
      //   id: null,
      //   title: null,
      //   status: false,
      //   baseNum: null,
      // };
      // this.$refs[formName].resetField();
      this.$router.back(-1)
    },
        //保存按钮
        submitForm(formName) {
          const that = this
      console.log(that.ruleForm);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (!that.edit) {
            that.$axioscBody
              .post("/backstage/hotOperational/edit", that.ruleForm)
              .then((r) => {
                if (r.code == 200) {
                  that.$message({
                    type: "success",
                    message: r.msg,
                  });
                  that.resetForm(formName);
                } else {
                  that.$alert(r.msg);
                }
              });
          } else {
            that.$axioscBody
              .put("/backstage/hotOperational/edit", that.ruleForm)
              .then((r) => {
                if (r.code == 200) {
                  that.$message({
                    type: "success",
                    message: r.msg,
                  });

                  that.resetForm(formName);
                } else {
                  that.$alert(r.msg);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    },
    mounted(){
        // this.editor = new wangEditor(this.$refs.wangEditor);
        // this.editor.customConfig.onchange =  (html) => { //通过富文本变化赋值
        //     // html 即变化之后的内容
        //     this.sendInfo.content=html;
        //     this.$vuerify.check(['sendInfo.content']);
        // }
        // this.editor.create();
    },
	created() {
    const {id} = this.$route.params
    this.id= id || void 0
    this.ruleForm.id= id || void 0
    if(id) this.getDetail(id)
	}
}
</script>

<style lang="scss" scoped>
.warp{
     height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
      padding:100px 0;
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
}
</style>
